/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Harvest_Cycle_PlaceholderInputs */

const en_harvest_cycle_placeholder = /** @type {(inputs: Harvest_Cycle_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Oct-Jan`)
};

const es_harvest_cycle_placeholder = /** @type {(inputs: Harvest_Cycle_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Oct-Ene`)
};

/**
* | output |
* | --- |
* | "e.g. Oct-Jan" |
*
* @param {Harvest_Cycle_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const harvest_cycle_placeholder = /** @type {((inputs?: Harvest_Cycle_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Harvest_Cycle_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_harvest_cycle_placeholder(inputs)
	return es_harvest_cycle_placeholder(inputs)
});